import { render, staticRenderFns } from "./newNews.vue?vue&type=template&id=7787f320&scoped=true&lang=html&"
import script from "./newNews.vue?vue&type=script&lang=js&"
export * from "./newNews.vue?vue&type=script&lang=js&"
import style0 from "./newNews.vue?vue&type=style&index=0&id=7787f320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7787f320",
  null
  
)

export default component.exports